import { SVGProps } from "react";

function SpinnerDotsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width={25} height={25} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx={2.06348} cy={12.3848} r={2.06348} fill="#A8B0B3" />
      <circle cx={22.6982} cy={12.3848} r={2.06348} fill="#A8B0B3" />
      <circle cx={12.3809} cy={2.06738} r={2.06348} fill="#A8B0B3" />
      <circle cx={12.3809} cy={22.7021} r={2.06348} fill="#171717" />
      <circle cx={19.6768} cy={5.08812} r={2.06348} transform="rotate(45 19.677 5.088)" fill="#A8B0B3" />
      <circle cx={5.08496} cy={19.6799} r={2.06348} transform="rotate(45 5.085 19.68)" fill="#A8B0B3" />
      <circle cx={19.6765} cy={19.6797} r={2.06348} transform="rotate(135 19.677 19.68)" fill="#A8B0B3" />
      <circle cx={5.08571} cy={5.08984} r={2.06348} transform="rotate(135 5.086 5.09)" fill="#A8B0B3" />
    </svg>
  );
}

export default SpinnerDotsIcon;
